/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Stagger_Finals_WarningInputs */



/**
* | output |
* | --- |
* | "Some players have played fewer rounds. Consider one more round before the finals to even it out." |
*
* @param {Overview_Stagger_Finals_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_stagger_finals_warning = /** @type {((inputs?: Overview_Stagger_Finals_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Stagger_Finals_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Certains joueurs ont joué moins de rondes. Envisagez une ronde de plus avant la finale pour équilibrer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algunos jugadores han jugado menos rondas. Considere una ronda más antes de la final para igualar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alguns jogadores jogaram menos rodadas. Considere mais uma rodada antes da final para equilibrar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Alcuni giocatori hanno giocato meno round. Valuta un round in più prima della finale per pareggiare.")
	return /** @type {LocalizedString} */ ("Some players have played fewer rounds. Consider one more round before the finals to even it out.")
});